import * as React from 'react';
import { SVGProps } from 'react';

const PeopleColored = ({ viewBox = '0 0 20 15', ...props }: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewBox} fill="none" {...props}>
    <g filter="url(#a)">
      <path
        fill="url(#b)"
        d="M2.25 2.75a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0ZM2 7.678c-.313.35-.5.816-.5 1.322 0 .506.188.972.5 1.322V7.675v.003Zm4.513-1.54A4.48 4.48 0 0 0 5 9.5a4.48 4.48 0 0 0 1 2.828V13c0 .553-.447 1-1 1H3c-.553 0-1-.447-1-1v-.838A3.502 3.502 0 0 1 3.5 5.5h1c.75 0 1.444.234 2.013.634v.003ZM14 13v-.672A4.48 4.48 0 0 0 15 9.5c0-1.338-.584-2.54-1.512-3.366A3.485 3.485 0 0 1 15.5 5.5h1a3.502 3.502 0 0 1 1.5 6.662V13c0 .553-.447 1-1 1h-2c-.553 0-1-.447-1-1Zm.25-10.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0ZM18 7.678v2.647c.313-.353.5-.816.5-1.322a1.98 1.98 0 0 0-.5-1.322v-.003ZM10 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM7.5 9.5c0 .506.188.969.5 1.322V8.175c-.313.353-.5.816-.5 1.322V9.5ZM12 8.178v2.647c.313-.353.5-.816.5-1.322a1.98 1.98 0 0 0-.5-1.322v-.003ZM14 9.5c0 1.397-.819 2.6-2 3.162V14c0 .553-.447 1-1 1H9c-.553 0-1-.447-1-1v-1.338A3.502 3.502 0 0 1 9.5 6h1C12.434 6 14 7.566 14 9.5Z"
      />
    </g>
    <defs>
      <radialGradient
        id="b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-.0201 11.89998 -16.99998 -.02872 10.02 3.1)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.024} stopColor="#67EBFF" />
        <stop offset={0.545} stopColor="#26A5FF" />
        <stop offset={1} stopColor="#3D52DD" />
      </radialGradient>
      <filter
        id="a"
        width={20}
        height={14.5}
        x={0}
        y={0.5}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.5} />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.446848 0 0 0 0 0.126602 0 0 0 0 1 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_18196_3305" />
      </filter>
    </defs>
  </svg>
);
export default PeopleColored;
